import React from "react"
import { Transition, TransitionGroup } from "react-transition-group"
import NodeInner from "./NodeInner"

import SEO from "./SEO"

const Node = ({ location, search, language, node, first }) => {
    const classes = `node node-${first ? "first" : "notfirst"}`

    if (!node) return null
    return (
        <>
            <SEO node={node} language={language} />
            <TransitionGroup className={classes} appear={true} enter={true}>
                <Transition
                    key={`${language}:${node._id.$oid}`}
                    unmountOnExit={true}
                    timeout={1000}
                >
                    {status => (
                        <NodeInner
                            status={status}
                            location={location}
                            search={search}
                            language={language}
                            node={node}
                            first={first}
                        />
                    )}
                </Transition>
            </TransitionGroup>
        </>
    )
}

export default React.memo(Node)
